export default __webpack_public_path__ + "static/media/_DSC0507.34398642.jpg";